// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kzHNKTBM{font-family:Inter;margin-top:0px;display:flex;gap:10px;align-items:flex-end}`, "",{"version":3,"sources":["webpack://./src/fsd/feature/banks/paginate-bank-item/ui/PaginateBankItem/PaginateBankItem.module.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,cAAA,CACA,YAAA,CACA,QAAA,CACA,oBAAA","sourcesContent":[".paginationWrapper {\n  font-family: Inter;\n  margin-top: 0px;\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationWrapper": `kzHNKTBM`
};
export default ___CSS_LOADER_EXPORT___;
